import { forwardRef } from "react";
import { IDropdownListItem } from "types/gaiaComponents/dropdownButton";
import { CheckIcon } from "lucide-react";
import { ICON_SIZE } from "components/common/constants";

export const DropdownListItem = forwardRef<HTMLButtonElement, IDropdownListItem>((props, ref) => {
    return (
        <button
            className={`ga-dropdown__item${props.disabled ? " ga-dropdown__item--disabled" : ""}${props.selected ? " ga-dropdown__item--selected" : ""}${props.active ? " ga-dropdown__item--active" : ""}`}
            type="button"
            role="option"
            aria-selected={props.selected}
            key={props.key}
            disabled={props.disabled}
            onClick={props.onClick}
            title={props.title}
            tabIndex={props.tabIndex ?? -1}
            data-testid={props.text}
            ref={ref}
        >
            <div className="ga-dropdown__item-label d-flex gap-8 w-100">
                {props.selected === true && <CheckIcon size={ICON_SIZE.SMALL}/>}
                {props.selected === false && <div className="mr-16" />}
                {props.text}
                {props.shortKey && (
                    <span className="ms-auto" aria-label={`Keyboard shortcut: ${props.shortKey}`}>
                        {props.shortKey}
                    </span>
                )}
            </div>
        </button>
    )
});
